import script from "./MySurveyAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./MySurveyAdmin.vue?vue&type=script&setup=true&lang=js"

import "./MySurveyAdmin.vue?vue&type=style&index=0&id=9cdef33c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cdef33c"]])

export default __exports__